import PropTypes from "prop-types";
import ChevronDown from "../icons/ChevronDown";
import "./ProductFilterCollapsible.scss";
import Collapse, { Panel } from "rc-collapse";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

export const ProductFilterCollapsible = ({ children, className, ...props }) => {
	const productFilterCollapsibleClassName = classNames("product-filter-collapsible", {
		[className]: className?.length > 0,
	});

	return (
		<Collapse
			className={productFilterCollapsibleClassName}
			accordion={true}
			expandIcon={({ isActive }) => <ChevronDown rotated={isActive} size={24} />}
			{...props}
		>
			{children}
		</Collapse>
	);
};

export const ProductFilterCollapsiblePanel = ({
	title,
	selectedFilter,
	children,
	className,
	...props
}) => {
	const productFilterCollapsiblePanelClassName = classNames("product-filter-collapsible-panel", {
		[className]: className?.length > 0,
	});

	return (
		<Panel
			{...props}
			className={productFilterCollapsiblePanelClassName}
			header={
				<>
					{selectedFilter?.length > 0 && (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.REGULAR}
							component="p"
							className="product-filter-collapsible-panel__selected-filters"
						>
							{selectedFilter}
						</Typography>
					)}

					{title}
				</>
			}
		>
			{children}
		</Panel>
	);
};

ProductFilterCollapsiblePanel.propTypes = {
	title: PropTypes.node.isRequired,
	selectedFilter: PropTypes.string,
};
